module.exports = __webpack_public_path__ + "documents/SprintCompleteMyHome_TOS.pdf";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/termspage/pdf/SprintCompleteMyHome_TOS.pdf
// module id = 3528
// module chunks = 0